import React from 'react';
import {useHasPermissions} from "hooks/useHasPermissions";
import EasasPageTemplateWrapper from "../../templates/EasasPageTemplateWrapper";


export default function AuthorizationManagementPage() {
    const isAllowed = useHasPermissions("ADMIN");

    return <EasasPageTemplateWrapper breadcrumb={["Authorization management"]} title="Authorization management" cardStyle={{height: "100%"}}>
        { isAllowed &&
        <div>
            <h1>Authorization management</h1>
        </div>
        }
        { !isAllowed &&
        <div>
            <h1>Unauthorized</h1>
        </div>
        }
    </EasasPageTemplateWrapper>
}
